export default __webpack_public_path__ + "static/media/P-039.4b5cb8e9.png";